'use strict';

/* jshint -W098 */
angular.module('mean.contractors').controller('ContractorsController', ['$scope', 'Global', 'Contractors', 'Users', '$filter',
  function($scope, Global, Contractors, Users, $filter) {
    $scope.global = Global;
    $scope.package = {
      name: 'contractors'
    };

    $scope.mtc_codes = [];

    for(var i=1; i<100; i++) {
        if(i < 10) {
            $scope.mtc_codes.push('0' + i);
        } else {
            $scope.mtc_codes.push(i);
        }
    };

    $scope.init = function() {
    	Users.query({}, function(users) {
    		$scope.contractor_users = $filter('filter')(users, { roles: 'mtc' });
            $scope.division_users = $filter('filter')(users, { roles: 'division' });
    	});

        Contractors.query(function(contractors) {
            if(contractors)
              $scope.contractors = contractors;
        });
    };

    $scope.checkCode = function(code) {
        var test = $filter('filter')($scope.contractors, {'code': $scope.selectedItem.code});

        if(test.length > 1) {
            $scope.codeError = true;
        } else {
            $scope.codeError = false;
        }
    };

    $scope.update = function() {
        if(!$scope.codeError) {
    	   $scope.selectedItem.$update();
        } else {
            alert('Could not save due to contractor code error');
        }
    };

    $scope.updateUser = function(index, user) {
    	$scope.selectedItem.division[index].name = user.name;
    	$scope.selectedItem.division[index].phone = user.phone;
    	$scope.selectedItem.division[index].email = user.email;
    	$scope.selectedItem.division[index].mtc_id = user._id;
    };

    $scope.addContractor = function(){
    	if (!$scope.name) {
    		alert('You must enter a contractor name');
    	}

    	var divs = []

    	for(var i=1; i<13; i++) {
    		if(i < 10) {
	    		divs.push({
	    			code: '0' + i
	    		});
	    	} else {
	    		divs.push({
	    			code: i
	    		});
	    	}
    	}

        $scope.codeError = true;

        var contractor = new Contractors({
            name: $scope.name,
            division: divs
        });

        contractor.$save(function(response) {
            $scope.name = response.name;
            $scope.contractors.push(response);

            $scope.name = '';
            $scope.selectedItem = contractor;
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/contractors/public/controllers/contractors.js